import { useEffect, useState } from "react";
import { Box, Tabs, Tab, Typography, FormControl } from "@mui/material";

import Base from "../../../Base/views/Base";
import { useDispatch, useSelector } from "react-redux";
import MonthTileView from "./Compnents/MonthTileView";
import MonthlyManagementView from "./Compnents/MonthlyManagementView";
import history from "../../../../../history";
import { GetWorkHoursAction } from "../../../../../store/Leave/WeekOff/Action";
import { GetLeaveTypeAction } from "../../../../../store/Leave/LeaveType/Action";
import { getUserData } from "../../../Base/helper/baseFunctions";
import { GetPayrollTileViewAction } from "../../../../../store/Finance/PayrollManagement/Action";
import { PayPeriodDateHelper } from "../../helper/Reports/GetWageReportHelper";
import { GetUserWorkLocationHelper } from "../../../Employee/helper/EmployeeHelper";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";


const PayrollManagementLandingPage = () => {
  const [currentView, setCurrentView] = useState("dashboard");
  const getRouteParams = () => {
  const params = new URLSearchParams(window.location.search);
      return {
          month: params.get("month"),
          type: params.get("type"),
          year: params.get("year"),
      };
  };

  const [currentType, setCurrentType] = useState(() => {
      const { type } = getRouteParams();
      return type || "Regular";
  });

  const [filters, setFilters] = useState(() => {
      const { year } = getRouteParams();
      return {
          year_only: year || String(new Date().getFullYear()),
      };
  });
  const dispatch = useDispatch();
  const userData = getUserData();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonthData, setCurrentMonthData] = useState({});
  const [paydate, setPayDate] = useState(null);
  
  let userRole;
  if (userData?.payroll_approver && (userData?.enable_payroll_executive || userData?.enable_finance_executive)) {
    userRole = "both";
  } else if (userData?.payroll_approver) {
    userRole = "approver";
  } else if (userData?.enable_payroll_executive || userData?.enable_finance_executive) {
    userRole = "admin";
  } else {
    userRole = "none";
  }
  const handleMonthClick = (month, monthData) => {
    setSelectedMonth(month);
    setCurrentMonthData(monthData);
    if (userRole === "approver") {
      setCurrentView("approver");
    } else {
      setCurrentView("admin");
    }
    try {
      const params = new URLSearchParams(window.location.search);
      params.set("month", String(month));
      params.set("type", currentType || "Regular");
      params.set("year", String(filters?.year_only));
      history.push({ pathname: window.location.pathname, search: params.toString() ? `?${params.toString()}` : "" });
    } catch (e) {}
    PayPeriodDateHelper({
        month: String(month),
        year: String(filters?.year_only)
    }).then((res) => {
        if (res?.data?.statuscode === 200) {
            setPayDate(res?.data?.data?.[0])
        }
    });
  };
  const [paySummaryTileData, setPaySummaryTileData] = useState([]);
  const { payrollTileViewLoading, payroll_tile_view_data } = useSelector(
    (state) => state.FinanceReducer?.PayrollManagementReducer
  );
  const handleFilter = (event) => {
    if (["year_only"].includes(event?.target?.name)) {
      const year = event.target.value;
      
      setFilters((prev) => ({
        ...prev,
        [event?.target?.name]: year,
      }));
      const params = new URLSearchParams(window.location.search);
      params.set("year", year);
      params.set("type", currentType);
      if (selectedMonth) {
          params.set("month", selectedMonth);
      } else {
          params.delete("month");
      }
      history.push({ pathname: window.location.pathname, search: params.toString() ? `?${params.toString()}` : "" });
    }
  };

   const [worklocationData, setWorklocationData] = useState({
      load: true,
      values: [],
    });
    const handleWorkLoacation = () => {
      setWorklocationData({ load: true, values: []})
      GetUserWorkLocationHelper().then(res => {
        if(res?.data?.statuscode === 200){
          setWorklocationData({ load: false, values: res?.data?.data || [] })
        } else {
          setWorklocationData({ load: false, values: [] })
        }
      })
    }
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const minDate = new Date(minDojYear);
  const minYear = minDate.getFullYear() - 1;
  const minMonth = minDate.getMonth() + 1;

  const selectedYear = Number(filters?.year_only);
  let allowedMonths;
  if (selectedYear === minYear) {
    allowedMonths = Array.from({ length: 12 - minMonth + 1 }, (_, i) => `${minMonth + i}`);
  } else if (selectedYear > minYear) {
    allowedMonths = Array.from({ length: 12 }, (_, i) => `${i + 1}`);
  } else {
    allowedMonths = [];
  }
  useEffect(() => {
    const receivedData = Array.isArray(payroll_tile_view_data)
      ? payroll_tile_view_data
      : [];
    const allMonths = Array.from({ length: 12 }, (_, i) => `${i + 1}`);
    const payrollTypes = ["Regular", "Work-Based", "Contractual"];

    // Prepare a map for each month
    const monthMap = {};
    allMonths.forEach((month) => {
      monthMap[month] = { month };
      payrollTypes?.forEach((type) => {
        // Default Pending Generation fields
        monthMap[month][`${type}_status`] = "Pending Generation";
        monthMap[month][`${type}_submitted_by`] = "";
        monthMap[month][`${type}_submittedon`] = null;
        monthMap[month][`${type}_approved_by`] = "";
        monthMap[month][`${type}_approvedon`] = null;
      });
    });

    // Fill in actual data
    receivedData?.forEach((item) => {
      const type = item?.payroll_type;
      const month = item?.month;
      monthMap[month][`${type}_status`] = item?.status;
      monthMap[month][`${type}_submitted_by`] = item?.submitted_by;
      monthMap[month][`${type}_submittedon`] = item?.submittedon;
      monthMap[month][`${type}_approved_by`] = item?.approved_by;
      monthMap[month][`${type}_approvedon`] = item?.approvedon;
    });

    // Convert map to array
    const completeData = allMonths?.map((month) => monthMap[month]);
    setPaySummaryTileData(completeData);
    if (selectedMonth) {
      const updatedMonthData = completeData?.find(
        (item) => item?.month === selectedMonth
      );
      if (updatedMonthData) setCurrentMonthData(updatedMonthData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payroll_tile_view_data]);

  useEffect(() => {
      const { month, type, year } = getRouteParams();
      const initialType = type || currentType;
      const initialYear = year || filters?.year_only;

      setCurrentType(initialType);
      setFilters((prev) => ({
          ...prev,
          year_only: initialYear,
      }));

      if (!type || !year) {
          const params = new URLSearchParams(window.location.search);

          params.set("type", initialType);
          params.set("year", initialYear);

          window.history.replaceState({}, "",`${window.location.pathname}?${params.toString()}`);
      }

      if (!month) {
          return;
      }
      setSelectedMonth(month);

      if (userRole === "approver") {
          setCurrentView("approver");
      } else {
          setCurrentView("admin");
      }
      PayPeriodDateHelper({
          month: String(month),
          year: String(initialYear),
      }).then((res) => {
          if (res?.data?.statuscode === 200) {
              setPayDate(res?.data?.data?.[0]);
          }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Clearing month will be handled explicitly on back button click.

  const handleTypeChange = (type) => {
    setCurrentType(type);
    try {
      const params = new URLSearchParams(window.location.search);
      params.set("type", type);
      params.set("year", String(filters?.year_only));
      if (selectedMonth) params.set("month", String(selectedMonth));
      history.push({ pathname: window.location.pathname, search: params.toString() ? `?${params.toString()}` : "" });
    } catch (e) {}
  }

  const handleBack = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has("month")) {
        params.delete("month");
        history.push({ pathname: window.location.pathname, search: params.toString() ? `?${params.toString()}` : "" });
      }
    } catch (e) {}
    setSelectedMonth(null);
    setCurrentMonthData({});
    setPayDate(null);
    setCurrentView("dashboard");
  }

  useEffect(() => {
    dispatch(GetPayrollTileViewAction({ year: filters?.year_only }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView, filters?.year_only]);

  useEffect(() => {
    dispatch(GetWorkHoursAction());
    dispatch(GetLeaveTypeAction());
    handleWorkLoacation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Base>
      <Box
        sx={{ height: "calc(100vh - 85px)", overflowY: "auto", p: 0.5, py: 1, position: "relative" }}
      >
        {currentView === "dashboard" ? (
          <>
            <BackdropMeepl open={payrollTileViewLoading} dark={false}/>  
            <Box>
              <Typography variant="h5">
                {userRole === "approver"
                  ? "Review and approve monthly pay summary reports"
                  : "Manage and track monthly pay summary reports"}
              </Typography>
            </Box>          
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Tabs
                value={currentType}
                onChange={(e, val) => handleTypeChange(val)}
                textColor="primary"
                indicatorColor="primary"
                sx={{
                  minHeight: "30px", ".MuiTab-root": { minHeight: "20px" },
                  '& .MuiTabs-indicator': {
                      width: '100%',
                      display: 'flex',
                      justifyContent: "center !important",
                  },
                }} 
              >
                <Tab label="Regular" value="Regular" />
                <Tab label="Work-Based" value="Work-Based" />
                <Tab label="Contractual" value="Contractual" />
              </Tabs>
              <Box width={"150px"}>
                <FormControl size="small">
                  <CommonDatePicker
                    name="year_only"
                    openTo="month"
                    views={["year"]}
                    label="Year"
                    pickerType="date"
                    size="small"
                    onKeyDown={(e) => e.preventDefault()}
                    onKeyPress={(e) => e.preventDefault()}
                    pickerFormat="yyyy"
                    DefaultDTvalue={filters?.year_only}
                    // minDate={new Date(new Date(minDojYear).getFullYear(), 0, 31)}
                    minDate={new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1))}
                    maxDate={
                      new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1)
                    }
                    handleChange={(value) => {
                      handleFilter({
                        target: {
                          name: "year_only",
                          value: value ? `${value.getFullYear()}` : "",
                        },
                      });
                    }}
                   
                  />
                </FormControl>
              </Box>
            </Box>
            <MonthTileView
              userRole={userRole}
              filters={filters}
              handleFilter={handleFilter}
              paySummaryTileData={ Array.isArray(paySummaryTileData) && paySummaryTileData?.length > 0
              ? paySummaryTileData?.filter(item => allowedMonths?.includes(item?.month))
              : []}
              handleMonthClick={handleMonthClick}
              currentType={currentType}
            />
          </>
        ) : (
          <Box>
            <MonthlyManagementView
              selectedYear={filters?.year_only}
              selectedMonth={selectedMonth}
              setCurrentView={setCurrentView}
              currentMonthData={currentMonthData}
              userRole={userRole}
              paydate={paydate}
              worklocationData={worklocationData}
              handleWorkLoacation={handleWorkLoacation}
              currentType={currentType}
              onBack={handleBack}
            />
          </Box>
        )}
      </Box>
    </Base>
  );
};
const getStatusColor = (status) => {
  switch (status) {
    case "Action Needed":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Pending Generation":
      return { bg: "#E5E7EB", text: "#374151" }; // gray
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
const MONTHS = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};
export { getStatusColor, MONTHS };
export default PayrollManagementLandingPage;
